import NoIcon from '@/assets/icons/noExpired.svg';
import CloseBtn from '@/assets/images/icons/close_black_24dp.svg';
import Button from '@/components/atoms/button/button';
import Modal from '@/components/atoms/modal/modal';
import { LoginGigyaInterface } from '@/shared/interfaces/LoginGigyaInterface';
import { changeRef } from '@/utils/location';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React, { useContext, useEffect, useState } from 'react';
import GlobalContext from '../../../contexts/globalContext';
import { TabsEnum } from '../../../enums/enums';
import UseDocumentType from '../../../hooks/useDocumentType';
import UseGetUserVerificatorDataTwo from '../../../hooks/useGetUserVerificatorDataTwo';
import { getVerificatorData } from '../../../services/verificator-services';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import HeaderTab from '../../atoms/header-tab/headerTab';
import Login from '../../atoms/login/login';
import BusinessModal from '../bussiness-modal/businessModal';
import ModalPermissionsBussines from '../modal-permissions-bussines/modalPermissionsBussines';
import SearcherBarHeader from '../search-bar-header/SearchBarHeader';
import './header.scss';

interface HeaderInterface {
    hideOnMobile?: boolean;
    openModal?: boolean;
    closeSubmenu?: () => void;
    closeMenuMobile?: () => void;
    setOpenModal: (openModalMobile: boolean) => void;
    isPrivate?: boolean;
    serviceId?: string;
}

const Header = ({
    hideOnMobile,
    openModal,
    closeSubmenu,
    closeMenuMobile,
    setOpenModal,
    isPrivate,
    serviceId,
}: HeaderInterface) => {
    const data = useStaticQuery(graphql`
        query GET_PORTAL_SERVICIOS_HEADER_DATA {
            allContentfulTemplate(
                filter: { nombre: { eq: "Header portal de servicios" } }
            ) {
                nodes {
                    imagen {
                        gatsbyImageData
                        file {
                            url
                        }
                    }
                    referencias {
                        ... on ContentfulTemplate {
                            redireccion
                            copyBoton
                            imagen {
                                title
                                file {
                                    url
                                }
                                gatsbyImageData(
                                    formats: [AUTO, WEBP]
                                    placeholder: BLURRED
                                )
                            }
                        }
                    }
                }
            }
            allContentfulMenuLoggin(
                filter: { titulo: { eq: "Menu login portal de servicios" } }
            ) {
                nodes {
                    inicioSesion
                }
            }
            allContentfulTransversal(
                filter: { tituloFiltro: { eq: "Transversal portal servicios" } }
            ) {
                nodes {
                    titulo
                    menuUsuario {
                        titulo
                        nombreEmpresa
                        descripcion {
                            raw
                        }
                        referencias {
                            ... on ContentfulTemplate {
                                titulo
                                nombre
                                redireccion
                                lista
                                imagen {
                                    title
                                    file {
                                        url
                                    }
                                    gatsbyImageData(
                                        formats: [AUTO, WEBP]
                                        placeholder: BLURRED
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const { referencias, imagen } = data.allContentfulTemplate.nodes[0];
    const tienda = data.allContentfulTemplate.nodes[0].referencias[2];
    const { inicioSesion } = data.allContentfulMenuLoggin.nodes[0];
    const [showInfoModal, setShowInfoModal] = useState(false);
    const {
        selectedTab,
        gigyaContext,
        business,
        userVerificationData,
        userInfoContext,
    } = useContext(GlobalContext);
    const menuUsuario = data.allContentfulTransversal.nodes.filter((menu) =>
        menu.titulo.includes(
            selectedTab?.get === TabsEnum.PEOPLE ? 'personas' : 'empresas'
        )
    )[0].menuUsuario;
    const { isBrowser, window, localStorage } = useBrowserMode();
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [openModalPermissionPage, setOpenModalPermissionPage] =
        useState(false);
    const [openHeaderModal, setOpenHeaderModal] = useState(false);
    const [showSearcher, setShowSearcher] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorShown, setErrorShown] = useState(false);

    const handleTabChange = (tab: TabsEnum) => {
        const bussinesOrigin = window.location.pathname.includes('empresas');

        if (tab === TabsEnum.BUSINESS) {
            if (business?.get) {
                if (bussinesOrigin) {
                    localStorage.setItem('CURRENT_TAB', tab);
                    selectedTab?.set(tab);
                }
            } else {
                if (!hideOnMobile && closeMenuMobile) {
                    closeMenuMobile();
                }

                if (!bussinesOrigin) {
                    localStorage.setItem('CURRENT_TAB', tab);
                    selectedTab?.set(tab);
                }
            }
            location.href =
                window?.location.hostname === 'localhost'
                    ? '/empresas'
                    : '/portal-servicios/empresas';
        }

        if (tab === TabsEnum.PEOPLE) {
            if (
                localStorage.getItem('CURRENT_TAB') !== tab &&
                selectedTab?.get !== tab
            ) {
                localStorage.setItem('CURRENT_TAB', tab);
                selectedTab?.set(tab);
                location.href =
                    tab === TabsEnum.PEOPLE &&
                    window?.location.hostname === 'localhost'
                        ? '/personas'
                        : '/portal-servicios/personas';
            } else {
                localStorage.setItem('CURRENT_TAB', tab);
                selectedTab?.set(tab);

                location.href =
                    window?.location.hostname === 'localhost'
                        ? '/personas'
                        : '/portal-servicios/personas';
            }
        }
    };

    useEffect(() => {
        const bussinesOrigin = window.location.pathname.includes('empresas');
        if (gigyaContext.gigyaAccount) {
            if (business?.get) {
                localStorage.setItem('CURRENT_TAB', TabsEnum.BUSINESS);
                selectedTab?.set(TabsEnum.BUSINESS);
                location.href =
                    window?.location.hostname === 'localhost'
                        ? '/empresas'
                        : '/portal-servicios/empresas';
            } else {
                localStorage.setItem(
                    'CURRENT_TAB',
                    bussinesOrigin ? TabsEnum.BUSINESS : TabsEnum.PEOPLE
                );

                selectedTab?.set(
                    window?.location.hostname === 'localhost' && bussinesOrigin
                        ? TabsEnum.BUSINESS
                        : TabsEnum.PEOPLE
                );
            }
        }
    }, []);

    useEffect(() => {
        if (gigyaContext?.gigyaAccount) {
            getVerificationData();
        }
    }, [gigyaContext.gigyaAccount]);

    const getVerificationData = async () => {
        if (errorShown) return;
        try {
            if (!gigyaContext?.gigyaAccount?.data?.docNumber) {
                console.warn('Número de documento no disponible');
                return;
            }
            const documentType = UseDocumentType(
                gigyaContext.gigyaAccount?.data.docType
            ).tipoDocumentoLegdos;
            const response = await getVerificatorData(
                gigyaContext.gigyaAccount.data.docNumber,
                documentType,
                userInfoContext.data?.userJwt
            );
            if (!response || !response.data) {
                throw new Error('Respuesta del servicio incompleta');
            }
            if (response.data.status === 500) {
                throw {
                    isServiceError: true,
                    message: response.data.userMessage,
                    response,
                };
            }
            if (response.data.data) {
                const userVerificatedData = UseGetUserVerificatorDataTwo(
                    response.data.data
                );
                userVerificationData?.set(userVerificatedData);
            } else {
                console.warn('Datos de respuesta vacíos');
            }
        } catch (error) {
            console.error('Error en verificación:', error);
            const currentPath = window.location.pathname;
            if (error.isServiceError || !error.response) {
                if (currentPath.includes('/mi-afiliacion/')) {
                    setIsError(true);
                    setErrorShown(true);
                } else {
                    console.warn(
                        'Servicio de verificación de derechos ha fallado'
                    );
                }
            } else {
                setTimeout(() => !errorShown && getVerificationData(), 3000);
            }
        }
    };

    const closeModal = () => {
        setOpenModal(false);
        setOpenHeaderModal(false);
    };

    const toggleFreeze = (isToggle: boolean) => {
        if (isToggle) {
            document.body.classList.add('freeze-page');
        } else {
            document.body.classList.remove('freeze-page');
        }
    };

    const closeModalPermissionPage = () => {
        window?.location?.assign(
            window?.location?.pathname?.includes('/certificados')
                ? changeRef('/certificados')
                : changeRef('/')
        );
        toggleFreeze(false);
        setOpenModalPermissionPage(false);
        setOpenModal(false);
    };

    const renderLoginButton = ({
        login,
        logout,
        updateProfile,
        gigyaAccount,
    }: LoginGigyaInterface) => {
        const loginButton = (
            <Login
                isMenuActive={false}
                title={inicioSesion}
                login={login}
                logout={logout}
                updateProfile={updateProfile}
                gigyaAccount={gigyaAccount}
                menuUser={menuUsuario}
                openModal={() => {
                    setOpenModal(true);
                }}
                setOpenHeaderModal={() => {
                    setOpenHeaderModal(true);
                }}
                isPrivate={isPrivate}
            />
        );

        if (isBrowser && window?.screen.width < 720) return <React.Fragment />;

        return loginButton;
    };

    const handleTabChangeTwo = () => {
        const bussinesOrigin = window.location.pathname.includes('empresas');
        const tab = localStorage.getItem('CURRENT_TAB');
        if (tab === TabsEnum.BUSINESS) {
            if (!business?.get) {
                if (!bussinesOrigin) {
                    localStorage.setItem('CURRENT_TAB', tab);
                    selectedTab?.set(tab);
                }
            } else if (bussinesOrigin) {
                localStorage.setItem('CURRENT_TAB', tab);
                selectedTab?.set(tab);
            }
            location.href =
                window?.location.hostname === 'localhost'
                    ? '/empresas'
                    : '/portal-servicios/empresas';
        }

        if (tab === TabsEnum.PEOPLE) {
            if (
                localStorage.getItem('CURRENT_TAB') !== tab &&
                selectedTab?.get !== tab
            ) {
                localStorage.setItem('CURRENT_TAB', tab);
                selectedTab?.set(tab);
                location.href =
                    tab === TabsEnum.PEOPLE &&
                    window?.location.hostname === 'localhost'
                        ? '/personas'
                        : '/portal-servicios/personas';
            } else {
                localStorage.setItem('CURRENT_TAB', tab);
                selectedTab?.set(tab);

                location.href =
                    window?.location.hostname === 'localhost'
                        ? '/personas'
                        : '/portal-servicios/personas';
            }
        }
    };

    const infoModal = () => {
        return (
            <div className="o-massive-certificate-form__modal__container">
                <div
                    className="o-massive-certificate-form__modal__container__closeBtn"
                    onClick={() => {
                        setShowInfoModal(false);
                    }}
                >
                    <img src={CloseBtn} alt="closeButton" />
                </div>
                <div className="o-massive-certificate-form__modal__container__content">
                    <div className="o-massive-certificate-form__modal__container__content__img">
                        <i className="icon-info-circle1" />
                    </div>
                    <div className="o-massive-certificate-form__modal__container__content__title">
                        <h2>¡Noticia importante de afiliaciones!</h2>
                    </div>
                    <div className="o-massive-certificate-form__modal__container__content__descriptionOne">
                        <p>
                            Este 16 de diciembre desde 7:00 a.m. realizaremos
                            mantenimiento de nuestra plataforma de afiliaciones,
                            por lo que no se podrán realizar afiliaciones de
                            trabajadores dependientes. El proceso volverá a la
                            normalidad este 17 de diciembre a las 12 m.m
                        </p>
                    </div>
                    <div className="o-massive-certificate-form__modal__container__content__buttons">
                        <Button
                            type="button"
                            classname="secondary"
                            text={'Entendido'}
                            onClickAction={() => handleTabChangeTwo()}
                            isDisabled={false}
                        />
                    </div>
                </div>
            </div>
        );
    };

    const handleClick = () => {
        setIsError(false);
        setErrorShown(false);
        navigate('/');
    };

    return (
        <GlobalContext.Consumer>
            {(data) => (
                <>
                    {isError && (
                        <Modal
                            onClose={() => {
                                setIsError(false);
                            }}
                            open={isError}
                        >
                            <div className="afiliationContent__modal">
                                <h2 className="afiliationContent__modal__title">
                                    !Ups¡ Algo salió mal
                                </h2>
                                <img src={NoIcon} alt="icon" />
                                <p className="afiliationContent__modal__msg">
                                    Ocurrió un problema en el servidor. Por
                                    favor, inténtalo de nuevo más tarde.
                                </p>
                                <button
                                    onClick={handleClick}
                                    className="family__button"
                                >
                                    Ir al inicio
                                </button>
                            </div>
                        </Modal>
                    )}
                    <header className="m-header" onClick={closeSubmenu}>
                        <div className="m-header__container-tabs">
                            <a
                                className={'m-menu__icon-wrapper'}
                                href={
                                    window?.location?.hostname === 'localhost'
                                        ? '/'
                                        : '/portal-servicios/personas'
                                }
                                rel="noopener noreferrer"
                                title="m-menu__icon"
                            >
                                <GatsbyImage
                                    className="m-menu__icon"
                                    image={imagen[0].gatsbyImageData}
                                    alt={imagen[0].title}
                                    loading="eager"
                                />
                            </a>
                        </div>
                        <div
                            className={`m-header__container-tabs ${
                                hideOnMobile ? 'hide-on-mobile' : ''
                            }`}
                        >
                            <HeaderTab
                                tabContent={referencias[0]}
                                isTabActive={
                                    selectedTab?.get === TabsEnum.PEOPLE
                                }
                                handleClick={() =>
                                    handleTabChange(TabsEnum.PEOPLE)
                                }
                            />
                            <HeaderTab
                                tabContent={referencias[1]}
                                isTabActive={
                                    selectedTab?.get === TabsEnum.BUSINESS
                                }
                                handleClick={() =>
                                    handleTabChange(TabsEnum.BUSINESS)
                                }
                            />
                        </div>
                        <div className="m-header__container-action">
                            {showSearcher ? (
                                <div className="m-header__container-action__searcherContainer">
                                    <div className="m-header__container-action__searcherContainer__searcher">
                                        <SearcherBarHeader
                                            type="comfama"
                                            placement="inside"
                                            defaultPlaceholder={'buscar'}
                                            setShowInfoModal={setShowInfoModal}
                                        />
                                    </div>
                                    <div className="m-header__container-action__searcherContainer__cancelBtn">
                                        <p
                                            onClick={() =>
                                                setShowSearcher(false)
                                            }
                                        >
                                            Cancelar
                                        </p>
                                    </div>
                                </div>
                            ) : (
                                <div className="m-header__container-action__iconsContainer">
                                    <div className="m-header__container-action__iconsContainer__separator show-on-mobile" />
                                    <div className="m-header__container-action__iconsContainer__redireccion">
                                        <a href={tienda.redireccion}>
                                            <i
                                                className={`icon-shopping-cart ${
                                                    hideOnMobile
                                                        ? 'hide-on-mobile'
                                                        : ''
                                                }`}
                                            />
                                            <p>{tienda.copyBoton}</p>
                                        </a>
                                    </div>
                                    <div
                                        className={`m-header__container-action__iconsContainer__separator ${
                                            hideOnMobile ? 'hide-on-mobile' : ''
                                        }`}
                                    />
                                    <div
                                        className={`login ${
                                            hideOnMobile ? 'hide-on-mobile' : ''
                                        }`}
                                    >
                                        {renderLoginButton(data.gigyaContext)}
                                    </div>
                                </div>
                            )}
                        </div>
                    </header>
                    {showInfoModal && (
                        <Modal
                            open={showInfoModal}
                            onClose={() => setShowInfoModal(false)}
                        >
                            {infoModal()}
                        </Modal>
                    )}
                    {openHeaderModal && (
                        <BusinessModal
                            closeModal={closeModal}
                            closeModalPermissionPage={closeModalPermissionPage}
                            isMobile={false}
                            setShowConfirmation={setShowConfirmation}
                            isPrivate={isPrivate}
                            serviceId={serviceId}
                        />
                    )}
                    {openModalPermissionPage &&
                        !openModal &&
                        gigyaContext?.gigyaAccount?.data?.servicesAuth?.length >
                            0 && (
                            <ModalPermissionsBussines
                                closeModal={closeModalPermissionPage}
                            />
                        )}
                    {showConfirmation && <>{showConfirmation}</>}
                </>
            )}
        </GlobalContext.Consumer>
    );
};

export default Header;
